// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"WAIYuU","dropdownToggle":"GmvQ1D","icon":"ZWWQS9","overlay":"_IQRLK","dropdownMenu":"_0zyJlS"};